/**
 * useMapData - Hook for transforming area data into map-friendly format
 */

import { useMemo } from 'react';
import type { BoundingRect } from '@/src/components/features/search/Map/types';
import type { AreaResponse } from '@/src/lib/api';

export const useMapBounds = (area?: AreaResponse): BoundingRect | undefined => {
  return useMemo(() => {
    if (!area || !area.minLat || !area.maxLat || !area.minLon || !area.maxLon) {
      return undefined;
    }

    return {
      northLat: area.maxLat,
      southLat: area.minLat,
      eastLng: area.maxLon,
      westLng: area.minLon,
    };
  }, [area]);
};

export const useGoogleMapsKey = (): string => {
  // For now, use environment variable directly
  // In production, this might come from a config service or be passed as prop
  const key = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY || process.env.GOOGLE_MAPS_KEY || '';

  if (!key && process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
    console.warn('Google Maps API key not found. Check that NEXT_PUBLIC_GOOGLE_MAPS_KEY is set in .env');  
  }

  return key;
};
